var setGuessed = function(obj,global) {
    if ($(obj).is(':checked') ) {
        global.response.answers[global.questionIndex].guessed = 'yes';
    } else {
        global.response.answers[global.questionIndex].guessed = 'no';
    }
}
module.exports = setGuessed;


//////////////////
// WEBPACK FOOTER
// ./src/setguessed.js
// module id = 232
// module chunks = 0